export function getPost(slug) {
    return this.get(`/api/posts/${slug}`)
}
